import React, { useState } from 'react';
import { products, merchConfig } from '../data/mock';
import { useCart } from '../context/CartContext';
import { toast } from 'sonner';
import { ShoppingCart } from 'lucide-react';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const [selectedSize, setSelectedSize] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [showSizeChart, setShowSizeChart] = useState(false);

  const handleAddToCart = () => {
    if (!selectedSize) {
      toast.error('Please select a size');
      return;
    }

    addToCart({
      name: product.name,
      price: product.price,
      size: selectedSize,
      quantity: quantity,
      image: product.images[0],
      productId: product.id
    });

    toast.success(`Added ${quantity} ${selectedSize} ${product.color.toUpperCase()} shirt(s) to cart`);
    setSelectedSize('');
    setQuantity(1);
  };

  return (
    <div className="product-card-detail">
      <div className="product-images-row">
        <div className="product-image-container">
          <img 
            src={product.images[0]} 
            alt={`${product.name} Front`}
            className="product-image"
          />
          <div className="product-badge">LIMITED</div>
        </div>
        <div className="product-image-container">
          <img 
            src={product.images[1]} 
            alt={`${product.name} Back`}
            className="product-image"
          />
        </div>
      </div>
      
      <div className="product-details-section">
        <h3 className="product-name-large">{product.name}</h3>
        <div className="price-container">
          <p className="product-price-large">${product.price.toFixed(2)}</p>
        </div>
        <p className="product-description">{product.description}</p>

        <div className="product-options">
          <div className="option-group">
            <label className="option-label">Size</label>
            <select 
              value={selectedSize}
              onChange={(e) => setSelectedSize(e.target.value)}
              className="product-select"
            >
              <option value="">Select size</option>
              {merchConfig.availableSizes.map(size => (
                <option key={size} value={size}>{size}</option>
              ))}
            </select>
          </div>

          <div className="option-group">
            <label className="option-label">Quantity</label>
            <select 
              value={quantity}
              onChange={(e) => setQuantity(Number(e.target.value))}
              className="product-select"
            >
              {[1,2,3,4,5].map(num => (
                <option key={num} value={num}>{num}</option>
              ))}
            </select>
          </div>
        </div>

        {/* Size Chart Section */}
        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
          <button
            type="button"
            onClick={() => setShowSizeChart(!showSizeChart)}
            style={{
              background: 'none',
              border: '2px solid #8B0000',
              color: '#8B0000',
              padding: '12px 20px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: 'bold',
              width: '100%'
            }}
          >
            {showSizeChart ? '▲ Hide Size Chart' : '▼ View Size Chart'}
          </button>

          {showSizeChart && (
            <div style={{
              marginTop: '15px',
              padding: '20px',
              background: '#0a0a0a',
              border: '2px solid #8B0000'
            }}>
              <h3 style={{ color: '#8B0000', marginBottom: '15px', fontSize: '18px' }}>
                SIZE CHART (inches)
              </h3>
              <div style={{ overflowX: 'auto' }}>
                <table style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  fontSize: '14px'
                }}>
                  <thead>
                    <tr style={{ borderBottom: '2px solid #8B0000' }}>
                      <th style={{ padding: '10px', textAlign: 'left', color: '#8B0000' }}>Size</th>
                      <th style={{ padding: '10px', textAlign: 'center', color: '#8B0000' }}>Width</th>
                      <th style={{ padding: '10px', textAlign: 'center', color: '#8B0000' }}>Length</th>
                      <th style={{ padding: '10px', textAlign: 'center', color: '#8B0000' }}>Sleeve</th>
                    </tr>
                  </thead>
                  <tbody>
                    {merchConfig.availableSizes.map(size => (
                      <tr key={size} style={{ borderBottom: '1px solid #333' }}>
                        <td style={{ padding: '10px', fontWeight: 'bold', color: '#fff' }}>{size}</td>
                        <td style={{ padding: '10px', textAlign: 'center' }}>{merchConfig.sizingChart.width[size]}"</td>
                        <td style={{ padding: '10px', textAlign: 'center' }}>{merchConfig.sizingChart.length[size]}"</td>
                        <td style={{ padding: '10px', textAlign: 'center' }}>{merchConfig.sizingChart.sleeve[size]}"</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <p style={{ fontSize: '13px', color: '#999', marginTop: '15px', marginBottom: '0' }}>
                * Sleeve length measured from center back
              </p>
            </div>
          )}
        </div>

        <button onClick={handleAddToCart} className="btn-add-to-cart">
          <ShoppingCart size={20} />
          ADD TO CART
        </button>
      </div>
    </div>
  );
};

const ProductSection = () => {
  return (
    <section id="shop" className="product-section">
      <div className="section-container">
        <h2 className="section-title death-metal-title">STORE</h2>
        <div className="product-grid-two">
          {products.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductSection;
